<template>
  <div>
    <Teleport to="#fast-title">Quel est votre besoin&nbsp;?</Teleport>
    <div class="fast-modal-content">
      <div class="form-group" :class="{ 'form-group-invalid': hasErrors }">
        <label for="title" class="text-body font-normal flex justify-between">
          <span>Votre projet en quelques mots</span>
          <span>{{ 50 - newTitle.length }}/50</span>
        </label>
        <FastInput
          v-model="newTitle"
          :inner-class="`${hasErrors ? 'is-invalid' : ''}`"
          autofocus="autofocus"
          placeholder="Ex : création de logo pour startup, refonte de charte graphique e-commerce..."
          type="text"
          name="title"
          @keyup.enter="handleNextStep"
        />
      </div>
    </div>
    <StepsNavigation
      :prev-step-hidden="true"
      :next-step-disabled="!isValid"
      @prevStep="handlePrevStep"
      @nextStep="handleNextStep"
    />
  </div>
</template>

<script>
import stepEvents from '../mixins/stepEvents'
import StepsNavigation from './StepsNavigation.vue'
import FastInput from '@/apps/shared/components/FastInput.vue'

export default {
  name: 'StepTitle',
  components: {
    StepsNavigation,
    FastInput
  },
  mixins: [stepEvents],
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      newTitle: this.title
    }
  },
  computed: {
    isValid() {
      const valid = this.newTitle.length > 1 && this.newTitle.length <= 50
      return valid
    },
    hasErrors() {
      return !this.isValid && this.newTitle.length > 0
    }
  },
  watch: {
    newTitle(newVal, oldVal) {
      this.$emit('attributeChange', 'title', newVal)
    }
  }
}
</script>

<style></style>
